import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const AdsDisplayBannerPage = withCompass(
  () => import("../../pages/AdsDisplayBannerPage")
);

export function PoojaJumaniRoutes() {
  return (
    <Switch>
      <Route path="/pj/ads-display-banner" component={AdsDisplayBannerPage} />
    </Switch>
  );
}

export const slug = "pj";
